import { render } from "./Historical_Loans.vue?vue&type=template&id=4f57161e"
import script from "./Historical_Loans.vue?vue&type=script&lang=js"
export * from "./Historical_Loans.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__